import { useState } from 'react'
import { useIntl } from 'react-intl'
import { defineMessages } from 'react-intl'
import { Button, useToast } from '@homebotapp/hb-react-component-catalog'
import { RemoveSavedSearchModal } from './RemoveSavedSearchModal'
import { SavedSearchModel } from '../../../../../types/savedSearches'
import { SavedSearchIcon } from '../SavedSearchIcon'
import { useDeleteSavedSearch } from '../../../../../hooks/listings/useDeleteSavedSearch'
import * as Sentry from '@sentry/browser'

export const MSG = defineMessages({
  label: {
    id: 'HomeSearch.listings.searchSaved.ariaLabel',
    defaultMessage: 'Search saved - click to delete saved search'
  },
  searchSaved: {
    id: 'HomeSearch.listings.searchSaved',
    defaultMessage: 'Search saved'
  },
  searchDeleted: {
    id: 'HomeSearch.listings.searchDeleted',
    defaultMessage: 'Search deleted successfully'
  }
})

interface RemoveSavedSearchButtonProps {
  savedSearchMatchingCurrentFilters: SavedSearchModel | null
}

export const RemoveSavedSearchButton = ({ savedSearchMatchingCurrentFilters }: RemoveSavedSearchButtonProps) => {
  const intl = useIntl()
  const toast = useToast()
  const [showModal, setShowModal] = useState(false)

  const { mutateAsync: deleteSavedSearch } = useDeleteSavedSearch()

  const handleDelete = () => {
    if (!savedSearchMatchingCurrentFilters?.id) {
      return
    }

    try {
      deleteSavedSearch({ deleteSavedSearchId: savedSearchMatchingCurrentFilters?.id })
      toast({
        status: 'success',
        title: intl.formatMessage(MSG.searchDeleted),
        duration: 4000
      })
    } catch (e) {
      Sentry.captureException(e)
    }
  }

  return (
    <>
      <Button
        minW='7rem'
        colorScheme='primary'
        onClick={() => setShowModal(true)}
        data-qa='turnOffListingsAlertsButton'
        aria-label={intl.formatMessage(MSG.label)}
        leftIcon={<SavedSearchIcon />}
      >
        {intl.formatMessage(MSG.searchSaved)}
      </Button>
      <RemoveSavedSearchModal
        deleteSavedSearch={handleDelete}
        showModal={showModal}
        hideModal={() => setShowModal(false)}
      />
    </>
  )
}
